import type { CSSProperties } from "react";

/**
 * Inline style that paints a media row's LQIP blur as the element background
 * (shown behind the real image while it loads). Returns undefined when no blur.
 */
export function blurStyle(blurDataUrl?: string | null): CSSProperties | undefined {
  if (!blurDataUrl) return undefined;
  return {
    backgroundImage: `url(${blurDataUrl})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
  };
}
